import { allowedFontFamilies, fontSizeOpts } from '@autosign/constants'
import { FontFamily, TemplateField } from 'database'
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  ToggleGroup,
  ToggleGroupItem,
} from 'ui'
import { FieldAttributesSignature } from '.'
import { usePDFStore } from '../../../stores/pdf.store'
import { nativeEnumToArray } from '../../../utils/native-enum-to-array'
import { IconBold, IconItalic, IconUnderline, Icon } from '@tabler/icons-react'
import { availableFonts } from '../../Signing/FieldsFormLayer/Signature'

const fontColors = [
  {
    label: 'Negro',
    value: '#000000',
  },
  {
    label: 'Blanco',
    value: '#FFFFFF',
  },
  {
    label: 'Morado',
    value: '#800080',
  },
  {
    label: 'Bordo',
    value: '#5F021F',
  },
  {
    label: 'Rojo',
    value: '#FF0000',
  },
  {
    label: 'Verde',
    value: '#008000',
  },
]

const toggleGroupOpts = [
  {
    type: 'bold',
    icon: IconBold,
  },
  {
    type: 'italic',
    icon: IconItalic,
  },
  {
    type: 'underline',
    icon: IconUnderline,
  },
] satisfies Array<{
  type: keyof TemplateField
  icon: Icon
}>

export const FieldAttributeFormat: FieldAttributesSignature = ({ field }) => {
  const updateField = usePDFStore((state) => state.updateField)

  return (
    <div className='space-y-2'>
      <label className='font-bold text-sm'>Formato</label>
      <div className='space-y-3'>
        <Select
          onValueChange={(value) =>
            updateField(field.id, {
              font_family: value as FontFamily,
            })
          }
          defaultValue={field.font_family}
        >
          <SelectTrigger size='sm'>
            <SelectValue placeholder='Selecciona una fuente' />
          </SelectTrigger>
          <SelectContent>
            {allowedFontFamilies.map((fontFamily) => {
              return (
                <SelectItem
                  key={fontFamily}
                  className='capitalize'
                  value={fontFamily}
                >
                  {fontFamily.replace('_', '')}
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select>

        <Select
          onValueChange={(value) =>
            updateField(field.id, {
              font_size: +value,
            })
          }
          defaultValue={field.font_size.toString()}
        >
          <SelectTrigger className='capitalize' size='sm'>
            <SelectValue placeholder='Selecciona un tamaño' />
          </SelectTrigger>
          <SelectContent>
            {fontSizeOpts.map((fontSize) => {
              return (
                <SelectItem
                  key={fontSize}
                  value={fontSize.toString()}
                  className='capitalize'
                >
                  {fontSize}
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select>

        <div className='items-start flex justify-start'>
          <ToggleGroup
            defaultValue={toggleGroupOpts
              .filter((toggleOpt) => !!field[toggleOpt.type])
              .map((opt) => opt.type)}
            onValueChange={(opts) => {
              updateField(
                field.id,
                opts.reduce(
                  (acc, curr) => {
                    return {
                      ...acc,
                      [curr]: true,
                    }
                  },
                  toggleGroupOpts
                    .filter((opt) => !opts.includes(opt.type))
                    .reduce((acc, curr) => {
                      return {
                        ...acc,
                        [curr.type]: false,
                      }
                    }, {})
                )
              )
            }}
            type='multiple'
          >
            {toggleGroupOpts.map((opt, index) => {
              return (
                <ToggleGroupItem key={index} value={opt.type}>
                  <opt.icon className='w-4 h-4' />
                </ToggleGroupItem>
              )
            })}
          </ToggleGroup>
        </div>

        <Select
          onValueChange={(value) =>
            updateField(field.id, {
              font_color: value,
            })
          }
          defaultValue={field.font_color}
        >
          <SelectTrigger className='capitalize' size='sm'>
            <SelectValue placeholder='Selecciona un color' />
          </SelectTrigger>
          <SelectContent>
            {fontColors.map((fontColor) => {
              return (
                <SelectItem
                  key={fontColor.value}
                  value={fontColor.value}
                  className='capitalize'
                >
                  {fontColor.label}
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
